// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const isNil = (value: any): value is null | undefined =>
  value === null || value === undefined;
